var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.348,
    height: 7.79,
    viewBox: "1091.978 479 9.348 7.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1101.098 483.446-3.116 3.116a.779.779 0 1 1-1.102-1.101l1.786-1.787h-5.91a.78.78 0 0 1 0-1.557h5.91l-1.786-1.786a.779.779 0 1 1 1.102-1.102l3.116 3.115a.78.78 0 0 1 0 1.102Z",
    fill: "#533ffb",
    fillRule: "evenodd",
    "data-name": "icons8-back_arrow"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bdf8f6dccc26ba6b588dbcd063e9da32.svg";
export { ForwardRef as ReactComponent };